import styled from "styled-components";
import { Link } from "react-router-dom";
import cartao from "../imgs/cartao.png";
import { Main, Container, Botoes, Voltar } from "../styles/GlobalStyled.js";

export default function Explicacao() {
  return (
    <Main>
      <Container>
        <Instrucoes>
          <h2>Vou te explicar!</h2>
          <h3>
            Para fazer a calibragem, precisamos de um item com{" "}
            <span>tamanho universal</span>. O cartão possui por padrão o tamanho
            de 5,4cm de altura e é um item que todo mundo tem por perto. Nossa
            aplicação <span>não terá acesso aos seus dados</span>, fique
            tranquila!
          </h3>
        </Instrucoes>

        <img src={cartao} alt="cartao" />

        <Botoes>
          <Link to={"/calibragem"}>
            <button>Entendi! Então vamos lá.</button>
          </Link>
          <Link to={"/instrucao-calibragem"}>
            <Voltar>Voltar</Voltar>
          </Link>
        </Botoes>
      </Container>
    </Main>
  );
}

const Instrucoes = styled.div`
  width: 80%;
  margin: 5% 0 5% 0;

  @media (min-width: 1300px) {
    margin: 5% 5% 20% 5%;
  }
`;
